import axios from 'axios';

class ImageUploadService {
  static getStatus({ imageId }) {
    return axios.get(`/images/${imageId}/status`).then(({ data }) => data);
  }
}

export default ImageUploadService;
